import { _URL } from "../../config.json";
import http from "./../http";

const apiEndpoint = _URL + "/api/item";

export function getPagers(query) {
  return http.post(`${apiEndpoint}/GetPager?${query}`);
}

export function getItemById(Id) {
  return http.get(`${apiEndpoint}/${Id}`);
}

export function editItem(obj) {
  debugger;
  if (obj.id !== "new" && obj.id !== "add") {
    return http.put(apiEndpoint, obj);
  } else {
    return http.post(apiEndpoint, obj);
  }
}

export function deleteItem(Id) {
  return http.delete(`${apiEndpoint}/${Id}`);
}

export function getItem(value) {
  return http.get(`${apiEndpoint}/?search=${value}`);
}

export function getAllParents() {
  return http.post(`${apiEndpoint}/GetAllParent`);
}

export function getAllChildren() {
  return http.post(`${apiEndpoint}/GetAllChildren`);
}

export function getAllItem() {
  return http.post(`${apiEndpoint}/GetAll`);
}

export function getNewItemCode(Id) {
  return http.post(`${apiEndpoint}/GetNew/?parentId=${Id}`);
}

export function getPagerItem(current, pageSize) {
  return http.post(
    `${apiEndpoint}/GetPager?PageNumber=${current}&PageSize=${pageSize}`
  );
}

export function searchItem(code, name, isMatching) {
  return http.post(
    `${apiEndpoint}/GetChildrenActiveSearch?Code=${code}&Name=${name}&IsMatching=${isMatching}`
  );
}

export function getActiveTreeItem(search, addId) {
  return http.post(
    `${apiEndpoint}/GetActiveTree/?search=${search}&addId=${addId}`
  );
}
